import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-formulaire-client',
  templateUrl: './formulaire-client.component.html',
  styleUrls: ['./formulaire-client.component.css']
})

export class FormulaireClientComponent {
  @Output() clientValide = new EventEmitter<any>();

  clientForm: FormGroup;

  modesPaiement = ['Espèces', 'Mobile Money', 'Virement', 'Carte bancaire'];

  constructor(private fb: FormBuilder) {
    this.clientForm = this.fb.group({
      nom: ['', Validators.required],
      telephone: ['', [Validators.required, Validators.pattern('^\\+?[0-9]{8,15}$')]],
      email: [''],
      modePaiement: ['', Validators.required]
    });
  }

  validerClient() {
    if (this.clientForm.valid) {
      this.clientValide.emit(this.clientForm.value);
    }
  }
}
